<template>
	<div>
		<h2>{{$t('detailPanel.headlineHistory')}}</h2>
		<div class="box venueWineHistoryContainer">
				<div v-if="isLoadingMoreHistory" class="text-center">
					<LoadingAnimation />
				</div>
				<ul class="venueWineHistory">
						<li v-for="item in displayedHistoryMessages" :key="item.id">
								<span class="date">{{ item.date }}</span> <span class="user">{{ item.user }}</span>
								<span class="message">{{ item.message }}</span>
						</li>
				</ul>
				<button v-if="!isLoadingMoreHistory && hasMoreItems" @click="loadAllHistory" class="load-all-button">
					<svg style="position: relative; top: -2px;" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M8 11.6728L12 15.6728M12 15.6728L16 11.6728M12 15.6728V6.47279C12 5.08208 12 4.38673 11.4495 3.60819C11.0837 3.09091 10.0306 2.45247 9.40278 2.36741C8.45789 2.23939 8.09907 2.42657 7.38143 2.80093C4.18333 4.46922 2 7.81603 2 11.6728C2 17.1956 6.47715 21.6728 12 21.6728C17.5228 21.6728 22 17.1956 22 11.6728C22 7.97138 19.989 4.73966 17 3.01061" stroke="#0CBA4A" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>
					</svg>
					{{ $t('detailPanel.loadAllHistory') }}
				</button>
		</div>
	</div>
</template>

<script>

import DataService from '@/services/StrapiService'
import DateTimeService from '@/services/DateTimeService'
import LoadingAnimation from '@/components/LoadingAnimation.vue'

export default {
		name: 'History',
		components: {
			LoadingAnimation,
		},
		props: {
			selectedWine: Object,
		},
		created() {
      // this function is only used when the first overlay is created
      this.loadWineHistory()
		},
		data () {
			return {
				historyMessages: [],
				fetchedHistoryCount: 0,
				isLoadingMoreHistory: false,
				showAll: false,
				initialDisplayCount: 10, // Anzahl der initial von API geholten Einträge
			}
		},
		computed: {
			displayedHistoryMessages() {
				return this.historyMessages;
			},
			hasMoreItems() {
				// Button anzeigen wenn nicht alle geladen und genau das Limit zurückkam (= es gibt potenziell mehr)
				return !this.showAll && this.fetchedHistoryCount >= this.initialDisplayCount;
			}
		},
		methods: {
			loadWineHistory() {
				this.isLoadingMoreHistory = true;
				const historyType = this.getHistoryType()
				this.historyMessages = []
				this.fetchedHistoryCount = 0
				// Initial: Nur limitierte Anzahl von API holen
				const limit = this.showAll ? -1 : this.initialDisplayCount;
				DataService.findVenueWineHistory(this.selectedWine.id, limit).then((response) => {
						const fetchedHistory = response["data"].data || [];
						this.fetchedHistoryCount = fetchedHistory.length;
						var historyArray = fetchedHistory
						var historyMessages = [];
						
						for (const history of historyArray) {
							if (history.venueWine == null || Object.keys(history.venueWine).length === 0) {
								continue;
							}
							var msg = "";
							const newDate = new Date(history.createdAt);
							const parsedDatetime = DateTimeService.dateToFormattedstring(newDate, true, this.$i18n.locale);
							let date = parsedDatetime + " - ";
							switch (history.type) {
								case historyType.delete:
                  if (history.after === "true") {
                    msg += this.$t("detailPanel.historyMessages.wineDeleted", { wineTitle: history.venueWine.title });
                  } else if (history.after === "false" && history.before === "true") {
                    msg += this.$t("detailPanel.historyMessages.wineRestored", { wineTitle: history.venueWine.title });
                  }
									break;
								case historyType.create:
									msg += this.$t("detailPanel.historyMessages.wineCreated", { wineTitle: history.venueWine.title });
									break;
								case historyType.change_amount:
									if (parseInt(history.before) > parseInt(history.after)) {
										msg += this.$t("detailPanel.historyMessages.reducedAmountBottles", { before: history.before, after: history.after });
									}
									else {
										msg += this.$t("detailPanel.historyMessages.increasedAmountBottles", { before: history.before, after: history.after });
									}
									break;
								case historyType.move_amount:
									if (history.venueWine.glassMode == true && history.newVenue == null) {
										if (Math.abs(history.beforeAfterDiff) > 1) {
											msg += this.$t("detailPanel.historyMessages.bottlesConvertedToGlasses", { bottleCount: Math.abs(history.beforeAfterDiff) });
										}
										else {
											msg += this.$t("detailPanel.historyMessages.bottleConvertedToGlasses", { bottleCount: Math.abs(history.beforeAfterDiff) });
										}
									}
									else {
										var newVenueTitle = "";
										if (history.newVenue) {
											newVenueTitle = `in Location ${history.newVenue.title}`;
										}
										if (Math.abs(history.beforeAfterDiff) > 1) {
											msg += this.$t("detailPanel.historyMessages.moevedWines", { bottleCount: Math.abs(history.beforeAfterDiff), venueName: newVenueTitle });
										}
										else {
											msg += this.$t("detailPanel.historyMessages.moevedWine", { bottleCount: Math.abs(history.beforeAfterDiff), venueName: newVenueTitle });
										}
									}
									break;
								case historyType.change_amount_glasses:
									if (history.beforeAfterDiff < 0) {
										msg += this.$t("detailPanel.historyMessages.reducedAmountGlasses", { amount: Math.abs(history.beforeAfterDiff) });
									}
									else {
										continue;
									}
									break;
								case historyType.move_amount_glasses:
									if (history.beforeAfterDiff < 0) {
										msg += this.$t("detailPanel.historyMessages.deletedGlasses", { amount: Math.abs(history.beforeAfterDiff) });
									}
									else {
										msg += this.$t("detailPanel.historyMessages.addedGlasses", { amount: Math.abs(history.beforeAfterDiff) });
									}
									break;
								case historyType.change_price:
									if (history.fieldName === "purchasePriceAvg") {
										if (parseFloat(history.before) > parseFloat(history.after)) {
											msg += this.$t("detailPanel.historyMessages.reducedPurchasePrice", { before: history.before, after: history.after });
										}
										else {
											msg += this.$t("detailPanel.historyMessages.increasedPurchasePrice", { before: history.before, after: history.after });
										}
									}
									if (history.fieldName === "sellingPrice") {
										if (parseFloat(history.before) > parseFloat(history.after)) {
											msg += this.$t("detailPanel.historyMessages.reducedSellingPrice", { before: history.before, after: history.after });
										}
										else {
											msg += this.$t("detailPanel.historyMessages.increasedSellingPrice", { before: history.before, after: history.after });
										}
									}
									if (history.fieldName === "glassPrice") {
										if (parseFloat(history.before) > parseFloat(history.after)) {
											msg += this.$t("detailPanel.historyMessages.reducedSellingPriceGlasses", { before: history.before, after: history.after });
										}
										else {
											msg += this.$t("detailPanel.historyMessages.increasedSellingPriceGlasses", { before: history.before, after: history.after });
										}
									}
									break;
								case historyType.create_purchase_price:
									msg += this.$t("detailPanel.historyMessages.addedSuplier");
									break;
								case historyType.delete_purchase_price:
									msg += this.$t("detailPanel.historyMessages.deletedSuplier");
									break;
								case historyType.change:
									var fieldString = this.$t("general.shelf");
									msg += this.$t("detailPanel.historyMessages.changedField", { fieldName: fieldString, before: history.before, after: history.after });
									break;
								case historyType.comments:
									msg += this.$t("detailPanel.historyMessages.changedTastingNote");
									break;
								case historyType.glass_mode:
									if (history.after === "true") {
										msg += this.$t("detailPanel.historyMessages.activatedGlasswise");
									}
									else {
										msg += this.$t("detailPanel.historyMessages.deactivatedGlasswise");
									}
									break;
								case historyType.wineSupplier:
									msg += this.$t("detailPanel.historyMessages.changedSuplier");
									break;
								case historyType.change_without_revenue:
									if (parseInt(history.before) > parseInt(history.after)) {
										msg += this.$t("detailPanel.historyMessages.deletedWineWithoutRevenue", { amount: Math.abs(history.beforeAfterDiff) });
									}
									else {
										msg += this.$t("detailPanel.historyMessages.increasedAmountBottlesWithoutRevenue", { amount: Math.abs(history.beforeAfterDiff) });
									}
									break;
								case historyType.none:
									break;
								default:
							}
							// Skip entries that produce no readable message (e.g. no-op delete
							// entries or unknown history types) instead of rendering an empty row.
							if (msg === "") {
								continue;
							}
							let user = this.$t('general.deletedEmployee')
							if(history.changedByUser != null) {
								user = history.changedByUser.username;
							}
							historyMessages.push({
								message: msg,
								date: date,
								user: user,
							});
						}
						this.historyMessages = historyMessages;
				}).catch((err) => {
					console.log(err);
				}).finally(() => {
					this.isLoadingMoreHistory = false;
				});
			},
			loadAllHistory() {
				this.isLoadingMoreHistory = true;
				this.showAll = true;
				this.loadWineHistory();
			},
			getHistoryType() {
				return {
					delete: "delete",
					create: "create",
					move: "move",
					change_amount: "change_amount",
					change_without_revenue: "change_without_revenue",
					move_amount: "move_amount",
					change_amount_glasses: "change_amount_glasses",
					move_amount_glasses: "move_amount_glasses",
					change_price: "change_price",
					create_purchase_price: "create_purchase_price",
					delete_purchase_price: "delete_purchase_price",
					change: "change",
					import: "import",
					wineSupplier: "wineSupplier",
					comments: "comments",
					glass_mode: "glass_mode",
					discard_amount: "discard_amount",
					discard_amount_glasses: "discard_amount_glasses",
					favorite: "favorite",
					none: "none"
				}
			}
		},
		watch: {
			selectedWine() {
				this.showAll = false;
				this.loadWineHistory();
			}
		},
}

</script>